import React from "react";
import { Route, Redirect } from "react-router-dom";
import PluginLayout from '../containers/layout/pluginLayout';

export default ({ component: C, props: cProps, ...rest }) =>
  <Route
    {...rest}
    render={props =>
        cProps.isAuthenticated
        ?  <PluginLayout {...props} {...cProps} component={(props) => <C {...cProps} {...props} />} />
            : <Redirect
                to={`/`}
              />}
  />;

  //</MainLayout><C {...props} {...cProps} />